

const upgradeToTeamTierSuccessUpdater = (payload) => {
  const organization = payload.getLinkedRecord('organization')
  if (organization) {
    organization.setValue(true, 'showConfetti')
    organization.setValue(true, 'showDrawer')
  }
}
export default upgradeToTeamTierSuccessUpdater
